// ---Getters

/**
 * Check if a cookie exists.
 * @param {string} cookieToFind Wich cookie to look.
 * @return Boolean
 */
export const existCookie = (cookieToFind) => {
  const cookies = document.cookie.split(';');
  return cookies.filter(c => c.split('=')[0].trim() === cookieToFind).length > 0;
};

/**
 * Encode a list of cookies to a valid Sandos format.
 * @param {array} cookieList Unidimensional Array of values to encode.
 * @return String
 */
export const encodeCookieList = (cookieList) => {
  const stringFormated = `['${cookieList.join("','")}']`;
  const encoded = encodeURI(stringFormated.replace(/'/g, '"'));
  return encoded;
};

// ---Setters

/**
 * Creates a cookie at the document.
 * @param {string} cookieName
 * @param {string} cookieValue
 * @param {string} [cookieExpireDate] When the cookie expires.
 */
export const setCookie = (cookieName, cookieValue, cookieExpireDate, sameSiteOpt = 'strict') => {
  const cookieExpire = cookieExpireDate ? `expires=${cookieExpireDate.toUTCString()}` : '';
  const sameSite = `samesite=${sameSiteOpt}`;
  const domain = window.location.hostname.split('.').slice(-2).join('.');
  document.cookie = `${cookieName}=${cookieValue};${cookieExpire};${sameSite};domain=${domain};path=/`;
};
